import React from 'react';
import clsx from 'clsx';
import {
  Pagination, Icon,
} from 'semantic-ui-react';
import TableStatistics from './TableStatistics';

const TablePagination = ({
  total,
  pageCount,
  currentPage,
  rows,
  className,
  goToPage,
}) => {
  const canNextPage = currentPage < pageCount;
  const canPreviousPage = currentPage > 1;

  return (
    <div className={clsx('pagination-bottom', className)}>
      <TableStatistics total={total} count={rows} />
      {pageCount > 1 && (
        <Pagination
          activePage={currentPage}
          onPageChange={(e, { activePage }) => goToPage({ append: false, page: activePage, pageSize: null })}
          size="mini"
          totalPages={pageCount}
          firstItem={canPreviousPage ? { content: <Icon name="angle double left" />, icon: true } : null}
          lastItem={canNextPage ? { content: <Icon name="angle double right" />, icon: true } : null}
          prevItem={canPreviousPage ? { content: <Icon name="angle left" />, icon: true } : null}
          nextItem={canNextPage ? { content: <Icon name="angle right" />, icon: true } : null}
          siblingRange={2}
          boundaryRange={2}
        />
      )}
    </div>
  );
};

export default TablePagination;
